import Immutable, { List } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';
import GroupSummary from './GroupSummary';
import { Interval } from 'domain/Interval';

const GroupRecord = Immutable.Record({
  id: undefined,
  name: undefined,
  number: undefined,
  centreId: undefined,
  closedTime: undefined,
  comments: undefined,
  status: undefined,
  teachers: undefined,
  courseTypeCode: undefined,
  groupSummary: undefined,
  period: undefined,
  languageCode: undefined,
  courseTypeLevelId: undefined,
  courseTypeLevelCode: undefined,
  members: ApiResponseHelper.create(),
  sessions: ApiResponseHelper.create(),
  sessionPlans: ApiResponseHelper.create(),
  progressReports: ApiResponseHelper.create(),
  autoPublishContent: undefined,
  enabledModuleCodes: undefined,
  isFromOdin: undefined,
  groupExternalUrl: undefined,
  onlineProductName: undefined,
  hasContentPath: undefined,
});

class Group extends GroupRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'centreId':
    case 'courseTypeLevelId':
      return [key, `${val}`]; // stringify
    case 'groupSummary':
      return [key, GroupSummary.create(val)];
    case 'period':
      return [key, Interval.create({
        start: val.startDate,
        end: val.endDate,
      })];
    case 'autoPublishContent':
    case 'enabledModuleCodes':
      return [key, new List(val)];
    default:
      return [key, Immutable.fromJS(val)];
  }
};
Group.create = (data) =>
  new Group(data).mapEntries(reviver);

export default Group;



// WEBPACK FOOTER //
// ./containers/Group/model.js